"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.getFullAddressFromPartial = getFullAddressFromPartial, exports.buildAddressStateFromRes = buildAddressStateFromRes, exports.isValidAddress = isValidAddress;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var ADDRESS_COMPONENT_MAP = {
  country: {
    target: "country",
    source: "long_name"
  },
  postal_code: {
    target: "postCode",
    source: "short_name"
  },
  administrative_area_level_1: {
    target: "state",
    source: "short_name"
  },
  street_number: {
    target: "streetNumber",
    source: "short_name"
  },
  route: {
    target: "street",
    source: "long_name"
  },
  locality: {
    target: "citySuburb",
    source: "short_name"
  }
};

function getAddressValue(a) {
  return a ? a.trim() : "";
}

function getFullAddressFromPartial(a) {
  return {
    country: getAddressValue(a.country),
    unit: getAddressValue(a.unit),
    street: getAddressValue(a.street),
    citySuburb: getAddressValue(a.citySuburb),
    state: getAddressValue(a.state),
    postCode: getAddressValue(a.postCode)
  };
}

function buildAddressStateFromRes(a) {
  var b = a.reduce(function (a, b) {
    var c = b.types.find(function (a) {
      return ADDRESS_COMPONENT_MAP[a];
    }),
        d = ADDRESS_COMPONENT_MAP[c];
    if (!d) return a;
    var e = d.target,
        f = d.source;
    return _objectSpread(_objectSpread({}, a), {}, (0, _defineProperty2["default"])({}, e, b[f]));
  }, {}),
      c = b.street,
      d = b.streetNumber,
      e = (0, _objectWithoutProperties2["default"])(b, ["street", "streetNumber"]);
  return _objectSpread({
    street: "".concat(d || "").concat(d && c ? " " : "").concat(c || "")
  }, e);
}

function isValidAddress(a) {
  return !!(a.street && a.country && a.citySuburb && a.state && a.postCode);
}